/**
 * Campaign and event artwork hosted on the CDN rather than shipped in the app.
 *
 * These are the largest images we had and none is needed on first paint of the
 * core app — Family Day, Dream Again, the gachapon machine, MD2024, Absolutely
 * chapter 1, the register background. Bundling them cost roughly 40 MB of every
 * live update *and* of the App Store download, because assets under `public/`
 * ship twice: once copied verbatim, once re-emitted by webpack for the
 * components that reference them by relative path.
 *
 * Kept in one file so the URLs are greppable and replaceable. They are opaque
 * upload ids, so the constant name is the only thing identifying them — keep the
 * names descriptive.
 *
 * Trade-off worth knowing: these pages now need the network. They were already
 * network-dependent for their content, but the artwork used to survive offline
 * and no longer does. Anything on the core offline path must not move here.
 */
const CDN = 'https://d1jjyi7mtgq26s.cloudfront.net/uploads';

export const REMOTE_ASSETS = {
  // Family Day
  fdBackground: `${CDN}/dc5a4ca3-3268-4e71-8a52-ff79ccd50a9e.webp`,

  // Dream Again (MD2023)
  dreamAgainDesktop: `${CDN}/ffaec753-662c-4011-8041-8276bcd3e246.webp`,
  dreamAgainMobile: `${CDN}/0d9efe6a-4ad9-4f85-bb2e-3133a28be72d.webp`,

  // Gachapon machine — composited, top and bottom must stay in proportion
  gachaponTop: `${CDN}/8c237833-3423-42e8-8dd2-f26e5f683561.webp`,
  gachaponBottom: `${CDN}/bfed3a44-0fb8-47c9-b7bb-f269254154d3.webp`,

  // MD2024
  md2024Part2: `${CDN}/a68c91c6-0840-481f-a34e-4a45b059d063.webp`,
  md2024Part3: `${CDN}/98731b67-1f3f-44fe-9583-11b5a2f029b2.webp`,
  md2024Part4: `${CDN}/7a3aedf8-ffb9-4dcf-a347-4606dc24ce85.webp`,
  md2024Part5: `${CDN}/7a15e227-44a8-43e0-83ea-0625db77ade0.webp`,

  // Absolutely
  absolutelyChapter1Title: `${CDN}/8e229eff-0a1c-4fe8-9dc0-693980d1736b.webp`,

  // Registration
  registerBackgroundGradient: `${CDN}/452431e4-73c7-4484-8083-e601cf12c884.webp`,

  // BF2026 pledge: a first-timer's submitted page (D1b–D4b), the "My 1st K" badge,
  // patch and stars on a paper ground, 750x1010 (2x of 375x505). The page is
  // reached only by submitting a pledge, so it is never offline.
  bfFirstTimerArtwork: `${CDN}/bf2026-first-timer-artwork-ef944563.webp`,
};

export default REMOTE_ASSETS;
